import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { ApiBaseUrl } from '../../config';

/**
 * Sin timeout, una request que queda colgada (el hosting compartido se queda
 * sin procesos, el proxy no cierra la conexión) nunca resuelve ni rechaza: la
 * pantalla se queda cargando para siempre, sin error y sin posibilidad de
 * reintentar.
 */
export const DEFAULT_TIMEOUT_MS = 30_000;

/** Las subidas de escrituras pueden ser de cientos de MB sobre líneas lentas. */
export const UPLOAD_TIMEOUT_MS = 15 * 60 * 1000;

const PasseriniAPI: AxiosInstance = axios.create({
  baseURL: ApiBaseUrl,
  timeout: DEFAULT_TIMEOUT_MS,
  headers: {
    'Accept': 'application/json'
  },
});

PasseriniAPI.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    if (!config.headers?.Authorization) {
      const token = localStorage.getItem("jwt");
      if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    // Subir un archivo con el timeout por defecto aborta la transferencia a los
    // 30 segundos. Se detecta por el cuerpo en vez de pedirle a cada llamada que
    // se acuerde de configurarlo.
    if (config.data instanceof FormData && config.timeout === DEFAULT_TIMEOUT_MS) {
      config.timeout = UPLOAD_TIMEOUT_MS;
    }

    return config;
  },
  error => Promise.reject(error)
);

export { PasseriniAPI };
